// Generated by `npm run data:oni` (scripts/data/oni.ts) from the Oceanic Niño
// Index in data/oni/. Do not edit by hand: change the script and run it.
// tests/enso.test.ts builds it again and fails if this file is not what the
// archive gives.
import type { EnsoPhase } from '../../types';

/**
 * NOAA Climate Prediction Center, Cold and Warm Episodes by Season, https://www.cpc.ncep.noaa.gov/products/analysis_monitoring/ensostuff/ONI_v5.php.
 * MEASURED by the script on the archived index:
 *
 * - 77 ENSO years, 1949-50 to 2025-26: nino 23, neutral 29, nina 25
 * - transitions, from (row) to (column), counted: nino 4/9/10; neutral 11/14/3; nina 8/6/11
 * - the chain's long-run shares 0.304 / 0.386 / 0.310 against the record's 0.299 / 0.377 / 0.325 (El Niño / neutral / La Niña)
 * - analog years 1982-83 on: nino 15, neutral 13, nina 16
 * - the record ends with JAS 2026 at 2.16 °C: 2026-27 is a nino year in progress, played on as 1997-98 (JAS 1997 at 1.79 °C)
 */

/** Every ENSO year (July to June) the record has a DJF season for: the year its July is in, its phase, the DJF departure, °C. */
export const ENSO_YEARS: ReadonlyArray<{ year: number; phase: EnsoPhase; djfC: number }> = [
  {"year":1949,"phase":"nina","djfC":-1.32},
  {"year":1950,"phase":"nina","djfC":-0.66},
  {"year":1951,"phase":"nino","djfC":0.52},
  {"year":1952,"phase":"neutral","djfC":0.25},
  {"year":1953,"phase":"neutral","djfC":0.41},
  {"year":1954,"phase":"neutral","djfC":-0.5},
  {"year":1955,"phase":"nina","djfC":-1.17},
  {"year":1956,"phase":"neutral","djfC":-0.27},
  {"year":1957,"phase":"nino","djfC":1.69},
  {"year":1958,"phase":"neutral","djfC":0.6},
  {"year":1959,"phase":"neutral","djfC":0.02},
  {"year":1960,"phase":"neutral","djfC":0},
  {"year":1961,"phase":"neutral","djfC":-0.16},
  {"year":1962,"phase":"neutral","djfC":-0.33},
  {"year":1963,"phase":"nino","djfC":0.95},
  {"year":1964,"phase":"nina","djfC":-0.51},
  {"year":1965,"phase":"nino","djfC":1.24},
  {"year":1966,"phase":"neutral","djfC":-0.46},
  {"year":1967,"phase":"neutral","djfC":-0.62},
  {"year":1968,"phase":"nino","djfC":0.98},
  {"year":1969,"phase":"neutral","djfC":0.46},
  {"year":1970,"phase":"nina","djfC":-1.29},
  {"year":1971,"phase":"nina","djfC":-0.57},
  {"year":1972,"phase":"nino","djfC":1.55},
  {"year":1973,"phase":"nina","djfC":-1.87},
  {"year":1974,"phase":"nina","djfC":-0.56},
  {"year":1975,"phase":"nina","djfC":-1.49},
  {"year":1976,"phase":"nino","djfC":0.71},
  {"year":1977,"phase":"nino","djfC":0.71},
  {"year":1978,"phase":"neutral","djfC":0.19},
  {"year":1979,"phase":"neutral","djfC":0.62},
  {"year":1980,"phase":"neutral","djfC":-0.27},
  {"year":1981,"phase":"neutral","djfC":-0.05},
  {"year":1982,"phase":"nino","djfC":2.14},
  {"year":1983,"phase":"nina","djfC":-0.63},
  {"year":1984,"phase":"nina","djfC":-1.01},
  {"year":1985,"phase":"neutral","djfC":-0.4},
  {"year":1986,"phase":"nino","djfC":1.18},
  {"year":1987,"phase":"nino","djfC":0.63},
  {"year":1988,"phase":"nina","djfC":-1.64},
  {"year":1989,"phase":"neutral","djfC":0.18},
  {"year":1990,"phase":"neutral","djfC":0.35},
  {"year":1991,"phase":"nino","djfC":1.54},
  {"year":1992,"phase":"neutral","djfC":0.13},
  {"year":1993,"phase":"neutral","djfC":0.07},
  {"year":1994,"phase":"nino","djfC":0.88},
  {"year":1995,"phase":"nina","djfC":-0.88},
  {"year":1996,"phase":"neutral","djfC":-0.41},
  {"year":1997,"phase":"nino","djfC":2.22},
  {"year":1998,"phase":"nina","djfC":-1.51},
  {"year":1999,"phase":"nina","djfC":-1.47},
  {"year":2000,"phase":"nina","djfC":-0.76},
  {"year":2001,"phase":"neutral","djfC":-0.15},
  {"year":2002,"phase":"nino","djfC":0.9},
  {"year":2003,"phase":"neutral","djfC":0.34},
  {"year":2004,"phase":"nino","djfC":0.62},
  {"year":2005,"phase":"nina","djfC":-0.86},
  {"year":2006,"phase":"nino","djfC":0.62},
  {"year":2007,"phase":"nina","djfC":-1.76},
  {"year":2008,"phase":"nina","djfC":-0.89},
  {"year":2009,"phase":"nino","djfC":1.47},
  {"year":2010,"phase":"nina","djfC":-1.29},
  {"year":2011,"phase":"nina","djfC":-0.71},
  {"year":2012,"phase":"neutral","djfC":-0.24},
  {"year":2013,"phase":"neutral","djfC":-0.24},
  {"year":2014,"phase":"nino","djfC":0.73},
  {"year":2015,"phase":"nino","djfC":2.5},
  {"year":2016,"phase":"neutral","djfC":-0.08},
  {"year":2017,"phase":"nina","djfC":-0.71},
  {"year":2018,"phase":"nino","djfC":0.99},
  {"year":2019,"phase":"nino","djfC":0.71},
  {"year":2020,"phase":"nina","djfC":-0.99},
  {"year":2021,"phase":"nina","djfC":-0.76},
  {"year":2022,"phase":"nina","djfC":-0.55},
  {"year":2023,"phase":"nino","djfC":1.84},
  {"year":2024,"phase":"neutral","djfC":-0.46},
  {"year":2025,"phase":"neutral","djfC":-0.39},
];

/** The chain: from one year's phase (row) to the next's, the shares of the record's transitions. */
export const ENSO_TRANSITION: Readonly<Record<EnsoPhase, Readonly<Record<EnsoPhase, number>>>> = {"nino":{"nino":0.1739,"neutral":0.3913,"nina":0.4348},"neutral":{"nino":0.3929,"neutral":0.5,"nina":0.1071},"nina":{"nino":0.32,"neutral":0.24,"nina":0.44}};

/** The observed years a drawn year of each phase is played as, by the year their July is in. */
export const ANALOG_YEARS: Readonly<Record<EnsoPhase, readonly number[]>> = {"nino":[1982,1986,1987,1991,1994,1997,2002,2004,2006,2009,2014,2015,2018,2019,2023],"neutral":[1985,1989,1990,1992,1993,1996,2001,2003,2012,2013,2016,2024,2025],"nina":[1983,1984,1988,1995,1998,1999,2000,2005,2007,2008,2010,2011,2017,2020,2021,2022]};

/** The year the record has begun and not finished: its phase so far, and the analog year it plays on as; null when the record ends on a June. */
export const YEAR_IN_PROGRESS: Readonly<{ year: number; phase: EnsoPhase; season: string; anomalyC: number; analogYear: number }> | null = {"year":2026,"phase":"nino","season":"JAS","anomalyC":2.16,"analogYear":1997};
